import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-545eabe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "demo-date-picker" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "dp__action_row d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "fs-8 mb-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["disabled", "onClick"]

import { ref, withDefaults, inject, computed, watch } from "vue";
import moment from "moment-timezone";
import { Emitter } from "mitt";
import { useRoute } from "vue-router";
import { TranslationService } from "@/core/services/TranslationService";
import { setDateRangeShortcuts } from "./DateRangeOptions";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { format } from "date-fns";
type DateRangeEmitter = {
  VZDateRange: string[];
};

export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: "daterange" },
    displayFormat: { default: "D/M/YYYY" }
  },
  setup(__props: any) {

const props = __props as { type: string, displayFormat: string }

const t = function (key: string) {
  return TranslationService.translate(key);
};
const databaseFormat = "YYYY-MM-DD";
const route = useRoute();

const selectedValue = ref([
  moment().subtract(6, "days").format(databaseFormat),
  moment().format(databaseFormat),
]);
const maxDateRange = ref(moment().format(databaseFormat));
const defaultValue = ref([
  moment().subtract(6, "days").format(databaseFormat),
  moment().format(databaseFormat),
]);
const emitter: Emitter<DateRangeEmitter> | undefined = inject("emitter");
const shortcuts = ref(setDateRangeShortcuts());
const routerName = computed(() => {
  return route.name;
});
const isApplyButtonActive = computed(() => {
  return (
    selectedValue.value?.length === 2 &&
    selectedValue.value.every((item) => moment(item).isValid())
  );
});
const displayDate = computed(() => {
  return process.env.VUE_APP_DATE_PICKER_FORMAT || "MM-dd-yyyy";
});
const emitDateRangeValue = () => {
  if (!isApplyButtonActive.value) {
    selectedValue.value.splice(1, 1, selectedValue.value?.[0]);
  }

  let endDate = `${moment(selectedValue.value?.[1], "YYYY-MM-DD HH:mm:ss")
    .endOf("day")
    .tz("UTC")
    .format()}`;
  if (
    maxDateRange.value ===
    moment(selectedValue.value?.[1]).format(databaseFormat)
  ) {
    endDate = `${moment(moment(), "YYYY-MM-DD HH:mm:ss")
      .endOf("day")
      .tz("UTC")
      .format()}`;
  }
  const date = [
    `${moment(selectedValue.value?.[0], "YYYY-MM-DD HH:mm:ss")
      .startOf("day")
      .tz("UTC")
      .format()}`,
    endDate,
  ];
  emitter?.emit("VZDateRange", date);
};
watch(
  routerName,
  () => {
    selectedValue.value = defaultValue.value;
  },
  { deep: true, immediate: true }
);

const resetDateRange = (closePicker: () => void) => {
  selectedValue.value = [...defaultValue.value];
  emitDateRangeValue();
  closePicker();
};
const formatDate = (date: any) => {
  if (!date) return "";

  if (Array.isArray(date)) {
    const [start, end] = date;
    if (!start || !end) return "";
    return `${format(start, "dd-MM-yyyy")} - ${format(end, "dd-MM-yyyy")}`;
  }

  return format(date, "dd.MM.yyyy");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Datepicker), {
        modelValue: selectedValue.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
          emitDateRangeValue
        ],
        range: "",
        multiCalendars: "",
        presetRanges: shortcuts.value,
        clearable: false,
        enableTimePicker: false,
        format: _unref(displayDate),
        selectText: `${t('common.apply')}`,
        maxDate: maxDateRange.value
      }, {
        "action-row": _withCtx(({ internalModelValue, selectDate, closePicker }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(formatDate(internalModelValue)), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn dp__reset",
                type: "button",
                onClick: ($event: any) => (resetDateRange(closePicker))
              }, _toDisplayString(t("common.reset")), 9, _hoisted_5),
              _createElementVNode("button", {
                class: "btn dp__select",
                type: "button",
                disabled: !_unref(isApplyButtonActive),
                onClick: selectDate
              }, _toDisplayString(t("common.apply")), 9, _hoisted_6)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "presetRanges", "format", "selectText", "maxDate"])
    ])
  ]))
}
}

})